module.exports = "../images/homepage/cycling.jpg";